var exports = {
  "i": "xaee3c4fa--0595ad--wrapper",
};

module.exports = exports;
